import { Chart } from "react-google-charts";
import { DashboardHeader } from "../Header";

const DashboardChart = ({
  title,
  type,
  data = [],
  height = "300px",
  legend = "bottom",
  colors = defaultChartColors,
  emptyMessage = "No data available",
}) => {
  const hasData =
    Array.isArray(data) &&
    data.length > 1 &&
    data.some((row) => row.slice(1).some((val) => val !== 0));

  const _data = data || [];

  const tooManyLabels = _data.length > 12;

  return (
    <div className="mb-4">
      {/* <h6 className="mb-2">{title}</h6> */}
      <DashboardHeader title={title} />
      {hasData ? (
        <div style={{ overflowX: "auto", overflowY: "hidden", width: "100%" }}>
          <div style={{ minWidth: tooManyLabels && `${_data.length * 100}px` }}>
            <Chart
              chartType={type}
              width="100%"
              height={height}
              data={_data}
              options={{
                title: "",
                pieHole: type === "PieChart" ? 0.4 : undefined,
                colors,
                legend: { position: legend },
                chartArea: { width: "90%", height: "70%" },
                hAxis: {
                  // slantedText: true,
                  // slantedTextAngle: 45, // or 60 for more rotation
                  textStyle: {
                    fontSize: tooManyLabels ? 11 : 12,
                  },
                },
              }}
            />
          </div>
        </div>
      ) : (
        <div className="border p-5 text-center text-muted">{emptyMessage}</div>
      )}
    </div>
  );
};

export default DashboardChart;

export const defaultChartColors = [
  // Block 1: Primary Red, Primary Yellow, Neutral Gray, Muted Blue Accent
  "#AC0207", // Deep Red (Primary)
  "#F7B811", // Warm Yellow (Primary)
  "#DDD", // Neutral Gray (Primary)
  "#4A90E2", // Muted Blue (Accent 1)

  // Block 2: Dark Red, Orange, Dark Gray, Muted Teal Accent
  "#701212", // Dark Red (Variant of Primary)
  "#FF9900", // Orange (Contrast to Red)
  "#999", // Darker Gray (Variation)
  "#5A7D7C", // Muted Teal (Accent 2)

  // Block 3: Strong Red, Soft Yellow, Light Gray, Soft Plum Accent
  "#C92C32", // Strong Complementary Red
  "#FFE083", // Soft Yellow (Highlights)
  "#B7B7B7", // Light Gray
  "#AF7AC5", // Soft Lavender/Plum (Accent 3)

  // Block 4: Muted Wine Red, Brighter Yellow, Mid-tone Gray, Muted Green
  "#8C2C2C", // Muted Wine Red
  "#FFC72C", // Brighter, more saturated Yellow
  "#C2C2C2", // Mid-tone Gray
  "#7D9A6B", // Olive Green (Earthy Accent)

  // Block 5: Lighter Vibrant Red, Golden Yellow, Very Light Gray, Dark Teal
  "#E04F50", // Brighter, more vibrant Red
  "#FFD700", // Golden Yellow
  "#E5E5E5", // Very Light Gray
  "#3D6B6A", // Dark Teal (Deeper Accent)

  // Block 6: Desaturated Red, Vibrant Orange, Dark Charcoal Gray, Muted Violet
  "#B33C3C", // Slightly Desaturated Red
  "#FFA500", // Vibrant Orange
  "#666", // Dark Charcoal Gray
  "#8C5A9F", // Muted Violet (Deeper Accent)

  // Block 7: Deeper Rich Red, Softer Orange, Almost White Gray, Muted Dark Blue
  "#A30000", // Deeper, richer Red
  "#FFB040", // Softer Orange
  "#F0F0F0", // Almost White Gray
  "#3A6C8C", // Muted Dark Blue (Deeper Accent)

  // Block 8: Muted Brick Red, Lighter Less Intense Yellow, Darker Neutral Gray, Soft Warm Gray
  "#902020", // Muted Brick Red
  "#FFCD38", // Lighter, less intense Yellow
  "#A0A0A0", // Slightly darker neutral Gray
  "#D9B086", // Soft Ochre/Warm Gray (Earthy Accent)

  // Block 9: Lighter Pastel Red, Pale Yellow, Lighter Mid-Gray, Desaturated Blue
  "#F56B6B", // Lighter, more pastel Red
  "#FFF2CC", // Very Pale Yellow (almost cream)
  "#CDCDCD", // Lighter Mid-Gray
  "#7B9EA8", // Desaturated Steel Blue (Subtle Accent)

  // Block 10: Rosy Red, Pale Orange, Darker Cool Gray, Muted Sage Green
  "#D64F50", // Rosy Red (similar to E04F50 but a touch softer)
  "#FFCC99", // Pale Orange
  "#888", // Slightly lighter than #999
  "#90A98F", // Muted Sage Green (Earthy Accent)

  // Block 11: Deep Crimson, Warm Brownish Yellow, Light Cool Gray, Muted Berry
  "#9F1A1A", // Deep Crimson
  "#E6B800", // Warm brownish Yellow (similar to F7B811, slightly darker)
  "#C7D1D1", // Light Cool Gray
  "#A84F60", // Muted Berry/Rose (Analogous Accent)

  // Block 12: Burnt Orange Red, Bright Lemon Yellow, Mid-Dark Gray, Dark Forest Green
  "#BF4020", // Burnt Orange-Red
  "#FFFF99", // Bright Lemon Yellow
  "#777", // Mid-Dark Gray
  "#2E5F40", // Dark Forest Green (Deep Earthy Accent)

  // Block 13: Terracotta Red, Soft Gold, Lighter Warm Gray, Medium Muted Blue
  "#D2691E", // Terracotta Red
  "#ECC84C", // Soft Gold (similar to FFD700, slightly more muted)
  "#DEDEDE", // Lighter Warm Gray
  "#6B8EAE", // Medium Muted Blue (Sky/Ocean Tone)

  // Block 14: Dark Rose, Soft Peach, Off-White, Dusty Plum
  "#B05252", // Dark Rose
  "#FFDAC1", // Soft Peach
  "#F8F8F8", // Off-White
  "#9A7C8C", // Dusty Plum (Muted Purple-Gray)
];